var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2693 9.02988C11.0701 9.02988 11.7193 8.3807 11.7193 7.57988C11.7193 6.77907 11.0701 6.12988 10.2693 6.12988C9.46852 6.12988 8.81934 6.77907 8.81934 7.57988C8.81934 8.3807 9.46852 9.02988 10.2693 9.02988Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88965 11.4098C7.88965 10.0998 8.95965 9.02979 10.2696 9.02979C11.5796 9.02979 12.6496 10.0998 12.6496 11.4098",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 12.3299C12.5343 12.3299 14.3699 10.4942 14.3699 8.22988C14.3699 5.96551 12.5343 4.12988 10.2699 4.12988C8.00555 4.12988 6.16992 5.96551 6.16992 8.22988C6.16992 10.4942 8.00555 12.3299 10.2699 12.3299Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9799 19.0198C18.5874 19.0198 19.0799 18.5273 19.0799 17.9198C19.0799 17.3123 18.5874 16.8198 17.9799 16.8198C17.3724 16.8198 16.8799 17.3123 16.8799 17.9198C16.8799 18.5273 17.3724 19.0198 17.9799 19.0198Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 20.8098C16.1797 19.8198 16.9897 19.0098 17.9797 19.0098C18.9697 19.0098 19.7797 19.8198 19.7797 20.8098",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9799 21.5101C19.692 21.5101 21.0799 20.1221 21.0799 18.4101C21.0799 16.698 19.692 15.3101 17.9799 15.3101C16.2678 15.3101 14.8799 16.698 14.8799 18.4101C14.8799 20.1221 16.2678 21.5101 17.9799 21.5101Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61953 19.0198C8.22704 19.0198 8.71953 18.5273 8.71953 17.9198C8.71953 17.3123 8.22704 16.8198 7.61953 16.8198C7.01202 16.8198 6.51953 17.3123 6.51953 17.9198C6.51953 18.5273 7.01202 19.0198 7.61953 19.0198Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81934 20.8098C5.81934 19.8198 6.62934 19.0098 7.61934 19.0098C8.60934 19.0098 9.41934 19.8198 9.41934 20.8098",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61953 21.5101C9.33161 21.5101 10.7195 20.1221 10.7195 18.4101C10.7195 16.698 9.33161 15.3101 7.61953 15.3101C5.90745 15.3101 4.51953 16.698 4.51953 18.4101C4.51953 20.1221 5.90745 21.5101 7.61953 21.5101Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62012 15.3102L9.16012 12.1802",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3203 10.98L17.1903 15.41",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6904 18.79H14.8704",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5495 5.55023C20.3945 5.55023 21.0795 4.86523 21.0795 4.02023C21.0795 3.17524 20.3945 2.49023 19.5495 2.49023C18.7045 2.49023 18.0195 3.17524 18.0195 4.02023C18.0195 4.86523 18.7045 5.55023 19.5495 5.55023Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2297 4.79004L14.4697 7.02004",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2996 12.5602C20.9623 12.5602 21.4996 12.0229 21.4996 11.3602C21.4996 10.6974 20.9623 10.1602 20.2996 10.1602C19.6369 10.1602 19.0996 10.6974 19.0996 11.3602C19.0996 12.0229 19.6369 12.5602 20.2996 12.5602Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 12.52L19.2295 15.41",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69023 13.5299C4.35298 13.5299 4.89023 12.9926 4.89023 12.3299C4.89023 11.6671 4.35298 11.1299 3.69023 11.1299C3.02749 11.1299 2.49023 11.6671 2.49023 12.3299C2.49023 12.9926 3.02749 13.5299 3.69023 13.5299Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50977 13.21L6.52977 15.41",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96953 5.37998C4.63227 5.37998 5.16953 4.84272 5.16953 4.17998C5.16953 3.51724 4.63227 2.97998 3.96953 2.97998C3.30679 2.97998 2.76953 3.51724 2.76953 4.17998C2.76953 4.84272 3.30679 5.37998 3.96953 5.37998Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0293 4.73975L6.8893 5.70975",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/Networking.7065f9283afee276cee0c985491d1862.svg";
export { ForwardRef as ReactComponent };